import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Calendar, DollarSign, TrendingUp, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { KPICard, DataTable, formatCurrency } from '../reportShared';

export default function MonthlyExposureTab({ monthlyExposure }) {
  return (
    <div className="space-y-6" data-testid="reports-monthly-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="Months Analyzed" value={monthlyExposure.length} icon={Calendar} color="blue" />
        <KPICard title="Total Exposure" value={formatCurrency(monthlyExposure.reduce((s, m) => s + m.amount, 0))} icon={DollarSign} color="green" />
        <KPICard title="Total Paid" value={formatCurrency(monthlyExposure.reduce((s, m) => s + m.paid, 0))} icon={TrendingUp} color="emerald" />
        <KPICard title="Pending Exposure" value={formatCurrency(monthlyExposure.reduce((s, m) => s + m.pending, 0))} icon={AlertTriangle} color="amber" />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Monthly Financial Trend</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={monthlyExposure}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Line type="monotone" dataKey="amount" stroke="#0088FE" strokeWidth={2} name="Total Amount" />
              <Line type="monotone" dataKey="paid" stroke="#10b981" strokeWidth={2} name="Paid" />
              <Line type="monotone" dataKey="pending" stroke="#f59e0b" strokeWidth={2} name="Pending" />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Monthly Breakdown</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={[
              { key: 'month', header: 'Month' },
              { key: 'claims', header: 'Claims', align: 'center' },
              { key: 'amount', header: 'Total Amount', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'paid', header: 'Paid', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'pending', header: 'Pending', align: 'right', render: (val) => formatCurrency(val) }
            ]}
            data={monthlyExposure}
          />
        </CardContent>
      </Card>
    </div>
  );
}
